import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import AuthenticatedLayout from "./components/AuthenticatedLayout";

import SelectedPlan from "./pages/cadastro/SelectedPlan";
import ContratacaoTelemedicina from "./pages/contratacaoTelemedicina";
import ContratacaoSucesso from "./pages/contratacaoSucesso";
import { LoginAppTokenPage } from "./pages/loginAppToken";
import ValidacaoCadastroLinkApp from "./pages/validacaoCadastroLinkApp";
import CadastroPagamentoApp from "./pages/cadastroPagamento/cadastroPagamento";
import TermosDeUso from "./pages/Termos";

import LoginPage from "./pages/Login";

import MinhaContaPage from "./pages/MinhaConta";
import AssinarPage from "./pages/Assinar";
import AtualizarPagamentoPage from "./pages/AtualizarPagamento";
import TelemedicinaPage from "./pages/Telemedicina";

export const routes = {
  medicos: "/app/medicos",
  telemedicina: "/app/telemedicina",
  plano: "/app/plano",
  dependentes: "/app/dependentes",
  consultas: "/app/consultas",
  perfil: "/app/perfil",
  pagamentoAssinatura: "/app/pagamentoAssinatura",
  pagamentoCadastro: "/app/pagamentocadastro",
  contratacaoTelemedicina: "/app/trocar-plano",
  telemedicinaEmpresa: "/app/telemedicina-empresa",
  contratacaoSucesso: "/app/sucesso",
  loginApp: "/login-app",
  validacao: "/validacao",
  assinatura: "/app/assinatura2",
};

export const routeObject: RouteObject[] = [
  { path: "/", element: <Navigate to="/login" replace={true} /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/cadastro", element: <SelectedPlan /> },
  { path: "/termos", element: <TermosDeUso /> },
  { path: "/login-app/:token", element: <LoginAppTokenPage /> },
  { path: "/contratar", element: <ValidacaoCadastroLinkApp /> },

  {
    path: "/app",
    element: <AuthenticatedLayout />,
    children: [
      {
        path: "/app",
        element: <Navigate to="/app/minha-conta" replace={true} />,
      },
      { path: "/app/minha-conta", element: <MinhaContaPage /> },
      { path: "/app/assinar", element: <AssinarPage /> },
      { path: "/app/atualizar-pagamento", element: <AtualizarPagamentoPage /> },
      { path: routes.telemedicina, element: <TelemedicinaPage /> },
      { path: routes.assinatura, element: <CadastroPagamentoApp /> },
      {
        path: routes.contratacaoTelemedicina,
        element: <ContratacaoTelemedicina />,
      },
      { path: routes.contratacaoSucesso, element: <ContratacaoSucesso /> },
    ],
  },
];

export default routes;
